const STORAGE_KEY_PREFIX = "education:lesson-position:";

export const getLessonLocalProgress = (lessonId: string): number => {
  try {
    const raw = localStorage.getItem(`${STORAGE_KEY_PREFIX}${lessonId}`);
    const value = Number(raw ?? 0);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
};

export const saveLessonLocalProgress = (
  lessonId: string,
  seconds: number,
): void => {
  try {
    localStorage.setItem(
      `${STORAGE_KEY_PREFIX}${lessonId}`,
      String(Math.max(0, Math.floor(seconds))),
    );
  } catch {
    // ignore quota / private mode
  }
};

export const clearLessonLocalProgress = (lessonId: string): void => {
  try {
    localStorage.removeItem(`${STORAGE_KEY_PREFIX}${lessonId}`);
  } catch {
    // ignore
  }
};

export const getResumePosition = (
  lessonId: string,
  apiProgressSeconds = 0,
): number => Math.max(apiProgressSeconds, getLessonLocalProgress(lessonId));
